<div class="flex flex-col items-start space-y-4">
  <button
    pButton
    class="w-full bg-white rounded-md p-4 flex items-center space-x-4 border-none md:border-[1px] md:border-solid md:border-light"
    (click)="redirectToContactUs()">
    <i class="pi pi-chevron-right text-base"></i>
    <span class="font-bold text-base">{{ "contractCard.makeRequest" | translate }}</span>
  </button>

  <div
    *ngIf="isGdaAllowed && isPolicyActive"
    class="w-full space-y-4">
    <div *ngFor="let claim of claims">
      <app-claims-button
        [policyReference]="this.policyReference"
        [claimsType]="claim.claimsType"
        [claimsRedirectValue]="claim.claimsRedirectValue"
        [text]="claim.text"
        [logo]="claim.logo">
      </app-claims-button>
    </div>
  </div>
</div>
